module.exports = __webpack_public_path__ + "static/images/header/descartes_logo.svg";